class ProductCardQuickAdd {
  constructor(form) {
    this.form = form;
    this.button = form.querySelector(
      '[data-product-card-quick-add-button]'
    );
    this.label = form.querySelector(
      '[data-product-card-quick-add-label]'
    );

    if (!this.button) return;

    this.defaultLabel = this.label?.textContent.trim() || '';
    this.loadingLabel = 'Adding...';
    this.addedLabel = 'Added';

    this.handleClick = this.handleClick.bind(this);

    this.button.addEventListener('click', this.handleClick);
  }

  async handleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.button.disabled || this.button.dataset.loading === 'true') {
      return;
    }

    this.setLoading(true);

    try {
      const formData = new FormData(this.form);

      formData.append('sections', 'ajax-cart');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(
        window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}cart/add.js`
          : '/cart/add.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.description ||
          responseData.message ||
          'Unable to add this product to the cart.'
        );
      }

      this.updateCartSection(
        responseData.sections?.['ajax-cart']
      );

      await this.refreshCart();

      this.showAddedState();
      this.openCart();

      document.dispatchEvent(
        new CustomEvent('product-card:added', {
          bubbles: true,
          detail: {
            product: responseData,
            sections: responseData.sections || {},
          },
        })
      );
    } catch (error) {
      console.error('Product card quick add:', error);

      document.dispatchEvent(
        new CustomEvent('product-card:error', {
          bubbles: true,
          detail: {
            message: error.message,
          },
        })
      );

      this.resetLabel();
    } finally {
      this.setLoading(false);
    }
  }

  updateCartSection(sectionHtml) {
    if (!sectionHtml) return;

    const cartStore = window.Alpine?.store('cart');

    if (!cartStore?.renderFromResponse) {
      console.error(
        'Product card quick add: Cart render method not found.'
      );
      return;
    }

    cartStore.renderFromResponse(sectionHtml);
  }

  async refreshCart() {
    const cartStore = window.Alpine?.store('cart');

    if (!cartStore?.getCardItems) return;

    await cartStore.getCardItems();
  }

  openCart() {
    const cartStore = window.Alpine?.store('cart');

    if (!cartStore?.openMiniCart) {
      console.error(
        'Product card quick add: Cart open method not found.'
      );
      return;
    }

    cartStore.openMiniCart();
  }

  setLoading(isLoading) {
    this.button.dataset.loading = isLoading ? 'true' : 'false';
    this.button.disabled = isLoading;

    if (this.label && isLoading) {
      this.label.textContent = this.loadingLabel;
    }
  }

  showAddedState() {
    if (!this.label) return;

    this.label.textContent = this.addedLabel;

    window.setTimeout(() => {
      this.resetLabel();
    }, 1500);
  }

  resetLabel() {
    if (this.label) {
      this.label.textContent = this.defaultLabel;
    }
  }
}

const initialiseProductCardQuickAdds = (container = document) => {
  container
    .querySelectorAll(
      '[data-product-card-quick-add]:not([data-quick-add-initialised])'
    )
    .forEach((form) => {
      form.dataset.quickAddInitialised = 'true';
      new ProductCardQuickAdd(form);
    });
};

document.addEventListener('DOMContentLoaded', () => {
  initialiseProductCardQuickAdds();
});

document.addEventListener('shopify:section:load', (event) => {
  initialiseProductCardQuickAdds(event.target);
});